function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#F5F5F5"
}, React.createElement("path", {
  d: "M369.16 3139.281l30.966 124.198c-66.984 16.701-134.825-24.062-151.527-91.047l-.725-2.91 121.286-30.241z",
  transform: "translate(-247 -3139)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 154,
    height: 129,
    viewBox: "0 0 154 129"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/figure-3.bdff6464.svg";
export { SvgComponent as ReactComponent };